.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  min-height: 100svh;
  padding: 20px;
  text-align: center;
  background: rgb(var(--cardColor));

  img {
    width: 100%;
    max-width: 295px;
  }

  h1 {
    display: flex;
    align-items: center;
    gap: 10px;
    color: rgb(var(--headingFontColor));
  }

  h2 {
    color: rgb(var(--textFontColor));
  }
}
